import { ErrorMessage, Field, useField, useFormikContext } from 'formik';
import React, { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Theme } from '../../../../interfaces/enums/Theme.enum';
import {
  getQuoteCostHeadlineInformation,
  setModalState,
} from '../../../../store/slices/quote/quote.store';
import { asCurrencyString } from '../../../../utils/asCurrencyString/asCurrencyString.util';
import { withBlokWrapper } from '../../../BlokWrapper/BlokWrapper';

interface QuoteTotalAndTermsBarProps {
  total_label: string;
  terms_and_conditions_heading: string;
  terms_and_conditions_body: string;
}

const QuoteTotalAndTermsBar: React.FC<QuoteTotalAndTermsBarProps> = ({
  total_label,
  terms_and_conditions_heading,
  terms_and_conditions_body,
}) => {
  const costHeadlineInformation = useSelector(getQuoteCostHeadlineInformation);
  const grandTotal = costHeadlineInformation?.grandTotal;
  const dispatch = useDispatch();
  // const { submitCount } = useFormikContext();

  // const [field, meta, helpers] = useField({
  //   name: 'accept-terms-and-conditions',
  //   validate: (value) => {
  //     if (value === false) {
  //       return 'Please accept our terms and conditions';
  //     }
  //   },
  // });

  return (
    <div className="p-10 text-text/body space-y-10">
      {grandTotal && (
        <div className="border-b border-b-border/light pb-8 flex items-center justify-between">
          <h3 className="text-4xl">{total_label}</h3>
          <p className="text-5xl font-bold">{asCurrencyString(grandTotal)}</p>
        </div>
      )}
      <div className="flex items-start justify-start gap-x-3">
        <Field
          id="accept-terms-and-conditions"
          type="checkbox"
          name="accept-terms-and-conditions"
          className="w-[18px] h-[18px] border-2 border-system/white rounded-xs bg-surface/background text-button/primary-bg"
        />
        <label htmlFor="accept-terms-and-conditions" className="space-y-3">
          <p className="font-bold text-xl leading-none">
            <a
              className="hover:underline"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                dispatch(
                  setModalState({
                    isQuoteModalOpen: true,
                    quoteModalContent: 'termsAndConditions',
                  })
                );
              }}
            >
              {terms_and_conditions_heading}
            </a>
          </p>
          {terms_and_conditions_body && <p>{terms_and_conditions_body}</p>}
        </label>
      </div>

      <ErrorMessage
        name="accept-terms-and-conditions"
        render={(msg) => (
          <div className="ml-8 text-text/body-primary">{msg}</div>
        )}
      />
    </div>
  );
};

export default memo(withBlokWrapper(QuoteTotalAndTermsBar, Theme.DARK));
